import { buildProfilePictureUrl } from "deso-protocol";
import type { Metadata } from "next";
import type { OpenGraph } from "next/dist/lib/metadata/types/opengraph-types";

import type { AccountByUsernameQuery } from "@/graphql/codegen/graphql";
import { META } from "@/utils/constants";
import type { PartialAccount } from "@/utils/types";
import { getUserName } from "@/utils/usernames";

export const isAccountCoinAccount = (account?: PartialAccount | null) => {
  if (!account) return false;
  // Note: Technically we should *also* check if the account has
  // any locked balance entries, but for now we're just checking
  // if the account has any dao coins in circulation (meaning unlocked).
  // It's highly unlikely that any single account would have all dao
  // coins locked. If that happens, we can update the CoreAccountFields
  // fragment to fetch a single LockedBalanceEntry to handle this edge
  // case. Even fetching the LockedBalanceEntry will be
  // significantly faster than using the TokenBalanceSummariesAsCreator
  // query to check if an account is a coin account.
  return (account.daoCoinsInCirculationNanosHex || "0x0") !== "0x0";
};

export const getMetaData = async (fullAccount: AccountByUsernameQuery) => {
  const title = `${getUserName({
    account: fullAccount?.accountByUsername as PartialAccount,
  })} • ${META.title}`;
  const description =
    fullAccount?.accountByUsername?.description || META.description;

  const meta: Metadata = {
    title,
    description,
    openGraph: {
      title,
      description,
    },
  };

  const imageURL =
    fullAccount.accountByUsername?.extraData?.NFTProfilePictureUrl ||
    buildProfilePictureUrl(fullAccount.accountByUsername?.publicKey ?? "", {
      nodeURI: process.env.NEXT_PUBLIC_CORE_DESO_NODE,
    });

  (meta.openGraph as OpenGraph).images = imageURL;

  return meta;
};
